<template>
  <div class="item-component">
    <div class="s-item-title">
      <h4 class="chart-title">
        <i class="el-icon-s-grid"></i>
        预报到统计人数
      </h4>
    </div>
    <chart-three style="height: 90%" :value="chartData"></chart-three>
  </div>
</template>

<script>
import ChartThree from "../charts/chart03";
import { chartData03 } from "@/assets/json/chartData";
import { mapState } from "vuex";
export default {
  components: {
    ChartThree,
  },
  data() {
    return {
      chartData: [],
      enrollmentYear: "", // 入学年份
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE", "_CURRENTYEAR","_CURRENT_ACADEMIC"]),
  },
  created() {
    this.enrollmentYear = this._CURRENTYEAR[0].value;
    this.getForcastNum();
  },
  mounted() {},
  methods: {
    // 获取各院系新生人数(已完成、未完成)
    getForcastNum() {
      let params = { enrollmentYear: this.enrollmentYear, academicDegree: this._CURRENT_ACADEMIC };
      this.$http
        .get("/welcome-forecast/statistics/getCollegeForecastNum", { params })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            // console.log(res);
            this.chartData = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>
